import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faBoxes,
  faPlane,
  faArrowRight,
  faTruck,
  faBox,
  faUndo,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../../styles/app/ServiceUPSSection.module.css";

const steps = [
  {
    number: "1",
    icon: faCalendarAlt,
    title: "Solicita tu recogida",
    description: "Programa la recolección de tu paquete desde cualquier lugar de USA.",
  },
  {
    number: "2",
    icon: faBoxes,
    title: "Recibimos tu paquete",
    description: "Nos encargamos de recibir tu paquete y entregarlo a la empresa de envío seleccionada para que continúe su traslado hasta el destino final",
  },
  {
    number: "3",
    icon: faPlane,
    title: "Enviamos y entregamos",
    description: "Enviamos tu paquete a tu país y lo entregamos en la puerta de tu casa.",
  },
];

const cards = [
  {
    icon: faTruck,
    title: "Recogida de Pickup",
    description: "Coordinamos la recolección de tus paquetes en la dirección que nos indiques.",
  },
  {
    icon: faBox,
    title: "Recibos Internacional",
    description: "Obtén una dirección física en USA para recibir, almacenar y consolidar tus compras.",
  },
  {
    icon: faUndo,
    title: "Devoluciones",
    description: "Te ayudamos a gestionar retornos de forma simple, rápida y segura.",
  },
  {
    icon: faFileAlt,
    title: "Envío de Documentos",
    description: "Traslado prioritario y seguro para documentación importante y trámites urgentes.",
  },
];

const ServiceUPSSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.titleWrapper}>
          <h2 className={styles.title}>¿Cómo funciona?</h2>
        </div>

        {/* Grid Superior: Pasos */}
        <div className={styles.stepsGrid}>
          {steps.map((step, idx) => (
            <React.Fragment key={step.number}>
              <div className={styles.stepItem}>
                <span className={styles.stepNumber}>{step.number}</span>
                <div className={styles.stepIconOuter}>
                  <FontAwesomeIcon icon={step.icon} className={styles.stepIcon} />
                </div>
                <div className={styles.stepText}>
                  <h3 className={styles.stepTitle}>{step.title}</h3>
                  <p className={styles.stepDesc}>{step.description}</p>
                </div>
              </div>
              {idx < steps.length - 1 && (
                <div className={styles.stepArrow}>
                  <FontAwesomeIcon icon={faArrowRight} />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Grid Inferior: Tarjetas (Ocultado a petición del usuario) */}
        {/*
        <div className={styles.cardsGrid}>
          {cards.map((card, idx) => (
            <div className={styles.cardItem} key={idx}>
              <div className={styles.cardIconOuter}>
                <FontAwesomeIcon icon={card.icon} className={styles.cardIcon} />
              </div>
              <h4 className={styles.cardTitle}>{card.title}</h4>
              <p className={styles.cardDesc}>{card.description}</p>
            </div>
          ))}
        </div>
        */}
      </div>
    </section>
  );
};

export default ServiceUPSSection;
